import { Icon } from './Icon'
import ai21Icon from '@lobehub/icons-static-svg/icons/ai21.svg'
import alibabaIcon from '@lobehub/icons-static-svg/icons/alibaba.svg'
import anthropicIcon from '@lobehub/icons-static-svg/icons/anthropic.svg'
import awsIcon from '@lobehub/icons-static-svg/icons/aws.svg'
import azureIcon from '@lobehub/icons-static-svg/icons/azure.svg'
import baiduIcon from '@lobehub/icons-static-svg/icons/baidu.svg'
import bytedanceIcon from '@lobehub/icons-static-svg/icons/bytedance.svg'
import cerebrasIcon from '@lobehub/icons-static-svg/icons/cerebras.svg'
import cloudflareIcon from '@lobehub/icons-static-svg/icons/cloudflare.svg'
import cohereIcon from '@lobehub/icons-static-svg/icons/cohere.svg'
import deepseekIcon from '@lobehub/icons-static-svg/icons/deepseek.svg'
import fireworksIcon from '@lobehub/icons-static-svg/icons/fireworks.svg'
import googleIcon from '@lobehub/icons-static-svg/icons/google.svg'
import groqIcon from '@lobehub/icons-static-svg/icons/groq.svg'
import huggingFaceIcon from '@lobehub/icons-static-svg/icons/huggingface.svg'
import ibmIcon from '@lobehub/icons-static-svg/icons/ibm.svg'
import metaIcon from '@lobehub/icons-static-svg/icons/meta.svg'
import microsoftIcon from '@lobehub/icons-static-svg/icons/microsoft.svg'
import minimaxIcon from '@lobehub/icons-static-svg/icons/minimax.svg'
import mistralIcon from '@lobehub/icons-static-svg/icons/mistral.svg'
import moonshotIcon from '@lobehub/icons-static-svg/icons/moonshot.svg'
import nousResearchIcon from '@lobehub/icons-static-svg/icons/nousresearch.svg'
import nvidiaIcon from '@lobehub/icons-static-svg/icons/nvidia.svg'
import ollamaIcon from '@lobehub/icons-static-svg/icons/ollama.svg'
import openAIIcon from '@lobehub/icons-static-svg/icons/openai.svg'
import openRouterIcon from '@lobehub/icons-static-svg/icons/openrouter.svg'
import perplexityIcon from '@lobehub/icons-static-svg/icons/perplexity.svg'
import qwenIcon from '@lobehub/icons-static-svg/icons/qwen.svg'
import togetherIcon from '@lobehub/icons-static-svg/icons/together.svg'
import xAIIcon from '@lobehub/icons-static-svg/icons/xai.svg'
import zhipuIcon from '@lobehub/icons-static-svg/icons/zhipu.svg'

interface Provider { label: string; icon: string }

const providers: Record<string, Provider> = {
  ai21: { label: 'AI21 Labs', icon: ai21Icon },
  alibaba: { label: 'Alibaba', icon: alibabaIcon },
  anthropic: { label: 'Anthropic', icon: anthropicIcon },
  amazon: { label: 'Amazon Web Services', icon: awsIcon },
  aws: { label: 'Amazon Web Services', icon: awsIcon },
  azure: { label: 'Microsoft Azure', icon: azureIcon },
  baidu: { label: 'Baidu', icon: baiduIcon },
  bytedance: { label: 'ByteDance', icon: bytedanceIcon },
  cerebras: { label: 'Cerebras', icon: cerebrasIcon },
  cloudflare: { label: 'Cloudflare', icon: cloudflareIcon },
  cohere: { label: 'Cohere', icon: cohereIcon },
  deepseek: { label: 'DeepSeek', icon: deepseekIcon },
  fireworks: { label: 'Fireworks AI', icon: fireworksIcon },
  google: { label: 'Google', icon: googleIcon },
  groq: { label: 'Groq', icon: groqIcon },
  huggingface: { label: 'Hugging Face', icon: huggingFaceIcon },
  ibm: { label: 'IBM', icon: ibmIcon },
  meta: { label: 'Meta', icon: metaIcon },
  'meta-llama': { label: 'Meta', icon: metaIcon },
  microsoft: { label: 'Microsoft', icon: microsoftIcon },
  minimax: { label: 'MiniMax', icon: minimaxIcon },
  mistral: { label: 'Mistral AI', icon: mistralIcon },
  mistralai: { label: 'Mistral AI', icon: mistralIcon },
  moonshot: { label: 'Moonshot AI', icon: moonshotIcon },
  moonshotai: { label: 'Moonshot AI', icon: moonshotIcon },
  nousresearch: { label: 'Nous Research', icon: nousResearchIcon },
  nvidia: { label: 'NVIDIA', icon: nvidiaIcon },
  ollama: { label: 'Ollama', icon: ollamaIcon },
  openai: { label: 'OpenAI', icon: openAIIcon },
  openrouter: { label: 'OpenRouter', icon: openRouterIcon },
  perplexity: { label: 'Perplexity', icon: perplexityIcon },
  qwen: { label: 'Qwen', icon: qwenIcon },
  together: { label: 'Together AI', icon: togetherIcon },
  'x-ai': { label: 'xAI', icon: xAIIcon },
  xai: { label: 'xAI', icon: xAIIcon },
  'z-ai': { label: 'Zhipu AI', icon: zhipuIcon },
  zhipu: { label: 'Zhipu AI', icon: zhipuIcon },
}

// CLI runs can have no model (expert submission grading), so the API sends null.
export function modelDisplayName(modelId?: string | null) {
  modelId ??= 'Unknown model'
  if (modelId === 'mockmodel' || modelId.startsWith('fake/')) return 'mock model'
  const separator = modelId.indexOf('/')
  return separator === -1 ? modelId : modelId.slice(separator + 1)
}

export function ModelLabel({ model: given, className = '' }: { model?: string | null; className?: string }) {
  const model = given ?? 'Unknown model'
  const mock = model === 'mockmodel' || model.startsWith('fake/')
  const separator = model.indexOf('/')
  const providerId = separator === -1 ? '' : model.slice(0, separator).toLowerCase()
  const provider = providers[providerId]
  const providerLabel = provider?.label ?? (providerId || 'Unknown provider')
  const fallback = providerLabel.slice(0, 2).toUpperCase()

  return <span className={`model-label ${className}`.trim()} title={`${providerLabel} · ${model}`} aria-label={mock ? 'mock model' : `${modelDisplayName(model)}, provided by ${providerLabel}`}>
    <span className={`model-provider-icon${provider || mock ? '' : ' fallback'}`} aria-hidden="true">
      {mock ? <Icon name="script" size={16} /> : provider ? <img src={provider.icon} alt="" /> : fallback}
    </span>
    <span className="model-label-name" aria-hidden="true">{modelDisplayName(model)}</span>
  </span>
}
